import { isInPremiumSupportFlight } from './isInPremiumSupportFlight';
import { isFeatureEnabled } from 'owa-feature-flags';

const PREMIUM_SUPPORT_CONTROL_FLIGHTNAME: string = 'auth-PremiumSupportControl';

export default async function isInPremiumSupportControlFlight() {
    if (isFeatureEnabled('auth-PremiumSupportControl')) {
        return await isInPremiumSupportFlight(PREMIUM_SUPPORT_CONTROL_FLIGHTNAME);
    }

    return false;
}
